<template>
    <div id="left-bar-crm">
        <ul>
            <li class="menu-title text-center">
                <i class="fas fa-address-book"></i>
                {{ $t("LeftBarCRM.crm") }}
            </li>
            <li class="has_sub">
                <router-link to="/crm/dashboard" class="waves-effect" :class="{ active: this.$route.name === 'crm-dashboard' }">
                    <i class="fa fa-chart-line"></i>
                    <span> {{ $t("LeftBarCRM.dashboard") }} </span>
                </router-link>
            </li>
            <transition name="slide-from-left" mode="out-in">
                <li v-if="$allCustomersSelected" class="has_sub" key="customer-list">
                    <router-link to="/crm/customers" class="waves-effect" :class="{ active: this.$route.name === 'customer-list' }">
                        <i class="fa fa-users"></i>
                        <span> {{ $t("LeftBarCRM.customerList") }} </span>
                    </router-link>
                </li>
                <li v-else-if="$customerSelected" class="has_sub" key="customer-profile">
                    <router-link to=/crm/customer class="waves-effect" :class="{ active: this.$route.name === 'customer-profile' }">
                        <i class="fas fa-user-tie"></i>
                        <span> {{ $t("LeftBarCRM.customerProfile") }} </span>
                    </router-link>
                </li>
            </transition>
        </ul>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
    name: "LeftBarCRM",
    props: {
        customers: {
            required: true,
        },
    },
};
</script>

<style lang="scss">
    @import "../../../assets/scss/colors";

    #left-bar-crm {
        .waves-effect {
            &.active {
                border-left-color: $crm-color;
                i {
                    color: $crm-color;
                }
            }
            .waves-ripple {
                background-color: rgba($crm-color, 0.45) !important;
            }
        }
    }
</style>